import { apiService } from "../api.service";

export const authService = {
  setPhoneNumber,
  removePhoneNumber,
  setUserTokens,
  removeUserTokens,
  setUserInfo,
  removeUserInfo,
  removeUser,
  refreshToken,
  startRefreshTokenTimer,
  setPinCode,
  setCustomer,
};

function setPhoneNumber(mobileNo) {
  localStorage.setItem("inputMobile", mobileNo);
}

function removePhoneNumber() {
  localStorage.removeItem("inputMobile");
}

function removeStoredData() {
  localStorage.removeItem("storedData");
}

function setUserTokens(token, refreshToken) {
  localStorage.setItem("jwtToken", token);
  localStorage.setItem("refreshToken", refreshToken);
}

function removeUserTokens() {
  localStorage.removeItem("jwtToken");
  localStorage.removeItem("refreshToken");
}

function setUserInfo(userInfo) {
  localStorage.setItem("customer", JSON.stringify(userInfo));
}

function removeUserInfo() {
  localStorage.removeItem("customer");
}

function removeUser() {
  removeUserInfo();
  removeUserTokens();
  removePhoneNumber();
  removeStoredData()
}

function refreshToken() {
  const refresh_token = localStorage.getItem("refreshToken");
  if (refresh_token) {
    apiService.refreshUserToken();
  }
}

function startRefreshTokenTimer(expires_in) {
  const timeout = expires_in * 60;
  setTimeout(() => apiService.refreshUserToken(), timeout);
}

function setPinCode(createPinCode) {
  localStorage.setItem("pinCode", JSON.stringify(createPinCode));
}

function setCustomer(customerUpdateInfo) {
  localStorage.setItem("customer", JSON.stringify(customerUpdateInfo));
}
